module.exports = __webpack_public_path__ + "img/mp3.2408ae31.png";